import React from "react";
import { Switch } from "@mui/material";
import BoltOutlinedIcon from "@mui/icons-material/BoltOutlined";
import EventSettingCard from "./EventSettingCard";

type EventUrgentSettingCardProps = {
  formData: { isUrgent?: boolean };
  handleChange: (
    event:
      | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
      | { target: { name: string; value: unknown } },
  ) => void;
};

const EventUrgentSettingCard: React.FC<EventUrgentSettingCardProps> = ({
  formData,
  handleChange,
}) => {
  return (
    <EventSettingCard
      icon={<BoltOutlinedIcon fontSize="small" />}
      title="Mark as urgent"
      description="Notify parents via email and push notifications."
      control={
        <Switch
          checked={Boolean(formData.isUrgent)}
          onChange={(event) =>
            handleChange({
              target: { name: "isUrgent", value: event.target.checked },
            })
          }
          color="primary"
        />
      }
    />
  );
};

export default EventUrgentSettingCard;
